import { render, staticRenderFns } from "./sendResHistory.vue?vue&type=template&id=645b2246&scoped=true&"
import script from "./sendResHistory.vue?vue&type=script&lang=js&"
export * from "./sendResHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b2246",
  null
  
)

export default component.exports